import React from 'react'
import {
  PaymentPage,
  FilterPage,
  FramePage,
  CapturePage,
  ResultPage,
  RetakePage,
  SelectPage,
  CheckoutPage,
  WelcomePage,
  CameraPage,
  EditPage,

} from './index'

// Import Bahela custom pages
import * as BahelaPages from '../bahela/index'
import * as BahelaEventPages from '../bahela/event'
import * as BahelaReceiptPages from '../bahela-receipt/index'
import * as BahelaQuickPages from '../bahela-quick/index'
import * as SamuPages from '../samu/index'
import * as PhotophoriaPages from '../photophoria/index'
import * as BoothDaughterPages from '../booth-daughter/index'
import * as YottaPages from '../yotta/index'

// Import Edit custom pages
import * as EditPages from '../edit/index'

// Import Newspaper custom pages
import * as NewspaperPages from '../newspaper/index'
import * as NewspaperAhboxPages from '../newspaper-ahbox/index'
import * as NewspaperKotabaruPages from '../newspaper-kotabaru/index'
import * as NewspaperTuguPages from '../newspaper-tugu/index'

// Add more custom path imports here as needed
// import * as OtherCustomPages from '../other-custom-path'

interface PageComponents {
  Welcome: React.ComponentType
  Camera: React.ComponentType
  Tutorial?: React.ComponentType
  Payment: React.ComponentType
  Filter: React.ComponentType
  Frame: React.ComponentType
  Capture: React.ComponentType
  Result: React.ComponentType
  Retake: React.ComponentType
  Select: React.ComponentType
  Edit: React.ComponentType
  Checkout: React.ComponentType

  Processing?: React.ComponentType
}

interface CustomRoutes {
  [key: string]: PageComponents
}

// Default pages as fallback
const defaultPages: PageComponents = {
  Welcome: WelcomePage,
  Payment: PaymentPage,
  Camera: CameraPage,
  Filter: FilterPage,
  Frame: FramePage,
  Capture: CapturePage,
  Result: ResultPage,
  Retake: RetakePage,
  Select: SelectPage,
  Edit: EditPage,
  Checkout: CheckoutPage,

}

// Map custom paths to their respective components
const customRoutes: CustomRoutes = {
  bahela: {
    ...defaultPages, // Fallback for any missing pages
    ...BahelaPages
  },
  bahelaevent: {
    ...defaultPages, // Fallback for any missing pages
    ...BahelaEventPages
  },
  bahelastruk: {
    ...defaultPages, // Fallback for any missing pages
    ...BahelaReceiptPages
  },
  'bahela-quick': {
    ...defaultPages,
    ...BahelaQuickPages
  },
  samu: {
    ...defaultPages, // Fallback for any missing pages
    ...SamuPages
  },
  samu2o: {
    ...defaultPages, // Fallback for any missing pages
    ...SamuPages,
    Welcome: WelcomePage
  },
  photophoria: {
    ...defaultPages, // Fallback for any missing pages
    ...PhotophoriaPages
  },
  'booth-daughter': {
    ...defaultPages, // Fallback for any missing pages
    ...BoothDaughterPages
  },
  yotta: {
    ...defaultPages, // Fallback for any missing pages
    ...YottaPages
  },
  edit: {
    ...defaultPages, // Fallback for any missing pages
    ...EditPages
  },
  newspaper: {
    ...defaultPages, // Fallback for any missing pages
    ...NewspaperPages
  },
  'newspaper-ahbox': {
    ...defaultPages, // Fallback for any missing pages
    ...NewspaperAhboxPages
  },
  'newspaper-kotabaru': {
    ...defaultPages, // Fallback for any missing pages
    ...NewspaperKotabaruPages
  },
  'newspaper-tugu': {
    ...defaultPages, // Fallback for any missing pages
    ...NewspaperTuguPages
  }
  // Add more custom paths here
  // other-path: {
  //   ...defaultPages,
  //   ...OtherCustomPages
  // }
}

export const getCustomRoutes = (customPath: string | undefined): PageComponents => {
  if (!customPath) return defaultPages
  return customRoutes[customPath] || defaultPages
}
